/**
 * Apartsales — Tab 4 (Сделки).
 *
 * Phase 1 spec: docs/architecture/25 §6 + 17-core-and-modules.md.
 * 9-step checkout progress, document signing, эскроу status.
 *
 * For now: placeholder explaining what will be here.
 */

import { createFileRoute } from '@tanstack/react-router';
import { TabStub } from '~/components/TabStub';

export const Route = createFileRoute('/deals')({
  component: DealsPage,
});

function DealsPage() {
  return (
    <TabStub
      title="Сделки"
      subtitle="9-шаговый чекаут в реальном времени"
      description="Прогресс каждой активной сделки: ДДУ, эскроу, УКЭП, ЕГРН. Pattern Stripe Dashboard — видно где сейчас и что осталось. В разработке."
      docRef="docs/architecture/17"
    />
  );
}
